import clsx from "clsx";
import type { ReactNode } from "react";

interface GuideSubtitleProps {
  children: ReactNode;
}

export function GuideSubtitle({ children }: GuideSubtitleProps) {
  return <h3 className={clsx("font-bold", "text-gray-800", "px-2")}>{children}</h3>;
}
